import Estimate from "@/usecases/orders/estimate";
import EstimatePurchaseItem from "./estimate-purchase-item";

export default class EstimatePurchase {
  public estimateId: number = 0;
  public estimateNumber: string = "";
  public projectId: number = 0;
  public projectName: string = "";
  public staffName: string = "";
  public title: string = "";
  public taxRate: number = 0;
  public items: EstimatePurchaseItem[] = [];

  public constructor(estimate: Estimate = new Estimate()) {
    this.estimateId = estimate.id;
    this.estimateNumber = estimate.estimateNumber;
    this.projectId = estimate.projectId;
    this.projectName = estimate.projectName;
    this.staffName = estimate.staffName;
    this.title = estimate.title;
    this.taxRate = estimate.taxRate;
    this.items = estimate.items
      .map(i => new EstimatePurchaseItem(i))
      .concat(
        estimate.children.flatMap(child =>
          new EstimatePurchase(child).items.map(
            i => new EstimatePurchaseItem(i)
          )
        )
      );
  }
}
